import React from "react";
import {
  FormItemProviderProps,
} from "../../../FormItemProvider";
import Port from "../../../../../../domain/Port";
import PortFormItemProvider from "../../ports/PortFormItemProvider";

const fieldName = "2nd Port";
const fieldType = "ETAPort2";

const ETAPort2FormItemProvider = (props: FormItemProviderProps<Port>): React.ReactElement => (
  <PortFormItemProvider
    {...props}
    fieldName={fieldName}
    fieldType={fieldType}
  />
);

export default ETAPort2FormItemProvider;